import {createSelector} from '@reduxjs/toolkit'

import {isEqual} from '@shared/helpers/lang'

import {RootState} from './interfaces'
import {createIssueNumberStr, getInitialState, validateIssueNumber} from './utils'

/** 현금영수증 */
export const cashReceiptSelector = (state: RootState) => state.cashReceipt

/** 현금영수증 신청 항목의 합쳐진 번호 */
export const issueNumberSelector = createSelector(cashReceiptSelector, ({issueNumber, issueType}) => {
    return {
        issueNumberStr: createIssueNumberStr({issueType, issueNumber}),
        valid: validateIssueNumber({issueType, issueNumber}),
    }
})

export const isStateInitializedSelector = createSelector(cashReceiptSelector, ({issueNumber}) => {
    return !isEqual(issueNumber, getInitialState().issueNumber)
})
